import { z } from 'my-zod'

const rentalProductMetricsModel = z.object({
  id: z.string(),
  outfitterId: z.number(),
  totalReservations: z.number(),
  previousReservations: z.number(),
  upcomingReservations: z.number()
})

export const RentalProductMetricsSchemas = {
  rentalProductMetricsModel: rentalProductMetricsModel
}

export declare namespace RentalProductMetricsSchemas {
  export type rentalProductMetricsModel = z.infer<typeof rentalProductMetricsModel>
}
